import React from "react";

export default function ListIcon({ props, active }) {
  return (
    <svg width={13} height={11} viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.73333 0H0V1.73333H1.73333V0ZM13.0001 0H3.46673V1.73333H13.0001V0ZM13.0001 4.33332H3.46673V6.06666H13.0001V4.33332ZM1.73333 4.33341H0V6.06674H1.73333V4.33341ZM0 8.66659H1.73333V10.3999H0V8.66659ZM3.46673 8.66668H13.0001V10.4H3.46673V8.66668Z"
        fill={active ? "#FFFDFE" : "#2B569F"}
      />
    </svg>
  );
}
